// extracted by mini-css-extract-plugin
export default {"burguerMenu":"HamburguerBtn_burguerMenu__sP2-8","burguer":"HamburguerBtn_burguer__2CH0q","clicked":"HamburguerBtn_clicked__eZVNN"};